// TODO: deprecate this as soon as Mongo API disappears
import t from '../helpers/i18n'

const oldRequest = (url, options = {}) => {
  return new Promise(async (resolve, reject) => {
    const base = (process.env.REACT_APP_OLD_API_URL.endsWith('/')) ?
      process.env.REACT_APP_OLD_API_URL.slice(0, -1) :
      process.env.REACT_APP_OLD_API_URL
    const uri = base + url
    fetch(uri, { credentials: 'include', ...options })
      .then(result => {
        result.json().then(response => {
          if (response.success) resolve(response.data)
          else if (response.code) reject({ code: response.code, error: response.error, data: response.data })
          else reject({ code: 'UNKNOWN_RESPONSE', error: 'Unknown response from the server' })
        }).catch(error => {
          reject({ code: 'INVALID_RESPONSE', error: 'Invalid response from the server' })
        })
      })
      .catch(result => {
        reject({ code: 'INTERNET_FAILURE', error: t('Internet Failure'), data: result })
      })
  })
}

const oldGet = (url) => {
  return oldRequest(url)
}

const oldPost = (url, data) => {
  return oldRequest(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers:{
      'Content-Type': 'application/json'
    }
  })
}

export { oldGet, oldPost }